import { Navigate } from 'react-router-dom';

export default function AdminPage() {
  return <Navigate to="/admin/jobs" replace />;
}
